import { render, staticRenderFns } from "./ClassList.vue?vue&type=template&id=2e36e26e&scoped=true"
import script from "./ClassList.vue?vue&type=script&lang=js"
export * from "./ClassList.vue?vue&type=script&lang=js"
import style0 from "./ClassList.vue?vue&type=style&index=0&id=2e36e26e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e36e26e",
  null
  
)

export default component.exports